// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Permanent+Marker&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

.navegador  {

  padding: 0;
  margin: 0;
  background-image: linear-gradient(to right,  rgb(8, 6, 2), rgb(90, 70, 73));
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

div {

  transition: all 1s;

}


.menu-titulo  {

  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding-top: 3%;
}

h1 {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 30px;
  font-weight: 600;
  color: white;
}


.titulo-opcion {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 20px;
  font-weight: 300;
  color: white;
  
}

.opciones {

  width: 100%;
  max-height: 30px;
  margin-left: 5px;
  margin-bottom: 2px;
  transition: max-height 0.5s ease-in-out;
  overflow: hidden;

}

.titulo-opcion:hover {

  cursor: pointer;
  background-color: rgb(83, 72, 72);

}

.nav {

  margin-left: 30px;


}

.activo {
 
  max-height: 250px;
  
}

.oculto {
 
  height: 30px;
 
}

.mostrar {

  display: block;

}

ul {

  transition: all 2s ease;

}

ul li {

  display: inline-flex;
  justify-content: space-evenly;
  align-items: center;
  width:max-content;
  margin-right: 15px;
  list-style: none;
  color: white;
  
}

ul li:hover {

  background-color: white;
  color: black;
}

a {
 
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 20px;
  margin-left: 10px;
  font-weight: 300;
  cursor: pointer;


}

a:hover {

  color: black;

}

i {

  font-size: 20px;

}

.linea {

  display: block;
  height: 1px;
  width: 200px;
  background-color: white;
  transition: width 2s ease-in;

}


.footer {

  /* position: fixed; */
 /* left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  
}

.footer h4 a{

  font-size: 20px;

}
*/

:root {

--color-white: white;

}

.navegador  {

  padding: 0;
  margin: 0;
  /* background-image: linear-gradient(to right,  rgb(8, 6, 2), rgb(90, 70, 73)); */
  background-color:  rgba(0,0,0,0.4); 
   height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.nav {

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: nowrap;
  overflow-y: hidden;
  overflow-x: auto;
  width: 100%;
  height: 100px;
 
  gap: 1em;
  position: relative;
  
  padding: 1.5rem;

}


.opciones {

  flex-shrink: 0;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1em;
  height: 60px;
  width: 180px;
  min-width: 180px;
  color: white;
  --color-white: white;
  border-bottom: 1px dotted white;
  cursor: pointer;

}

.opciones:hover {

  background-color: white;
  color: black;
  --color-white: black;
  border-bottom: 1px dotted black;

}

.activo {

  /* background-color: rgba(231, 101, 14, 0.5); */

  border-bottom: 2px solid white;

}

.nav::-webkit-scrollbar {

  width: 0.5rem;
  height: 0.5rem;

}

.nav::-webkit-scrollbar-thumb {

 border-radius: 0.5rem;
 background-color: white;
 visibility: hidden;

}

.nav:hover::-webkit-scrollbar-thumb {

  visibility: visible;

}

.titulo-opcion {

  font-size: 17px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center  ;
  flex-wrap: wrap;
  color: var(--color-white);

}

.items  {

  margin:10px;
  display:flex;
  position: relative;
  width: 100%;
  height: auto;

}

ul {

  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: auto;
  gap: 0.5em;
  width: 100%;
  padding-right: 20px;
}


li {

  margin:5px;
   display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
  font-size: 15px;
  width: 100px;
  min-width: 100px;
  height: 100px;
  color: white;
  border-bottom: 1px dotted white;
  padding: 5px;
  cursor: pointer;
}


li:hover {

  background-color: white;
  color: black;
  border-bottom: 1px dotted black;
  --color-white:black;
}

a {

  text-decoration: none;
  text-align: center;
  cursor: pointer;
  margin: 0;
  padding: 0;
  color: var(--color-white);

}

i {

  margin: 0;
  padding: 0;
}

.perfil {

  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

}

.footer {

  /* position: fixed; */
 left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  
}

.footer h4 a{

  font-size: 20px;

}

.menu-titulo  {

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  flex-wrap: wrap;
  color: white;
  padding-top: 3%;
}

.menu-titulo p {

  font-size: 20px;
  align-items: center;
}


.md-48 {

  font-size: 48px;
}


.material-symbols-outlined {
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}
`, "",{"version":3,"sources":["webpack://./src/app/slider/footer/footer.component.css"],"names":[],"mappings":"AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;uBAoJuB;CACtB;;;;;;;;;;;;;CAaA;;AAED;;AAEA,oBAAoB;;AAEpB;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,iFAAiF;EACjF,kCAAkC;GACjC,aAAa;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;;EAEb,QAAQ;EACR,kBAAkB;;EAElB,eAAe;;AAEjB;;;AAGA;;EAEE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;;AAEjB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;;AAEjC;;AAEA;;EAEE,+CAA+C;;EAE/C,8BAA8B;;AAEhC;;AAEA;;EAEE,aAAa;EACb,cAAc;;AAEhB;;AAEA;;CAEC,qBAAqB;CACrB,uBAAuB;CACvB,kBAAkB;;AAEnB;;AAEA;;EAEE,mBAAmB;;AAErB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;;AAE3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;;AAEd;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;;AAGA;;EAEE,UAAU;GACT,aAAa;EACd,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,eAAe;AACjB;;;AAGA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;EACV,yBAAyB;;AAE3B;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;;EAEE,qBAAqB;CACtB,OAAO;EACN,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;;EAEE,eAAe;AACjB;;;AAGA;EACE;;;;;AAKF","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Permanent+Marker&display=swap');\r\n\r\n/*\r\n\r\n.navegador  {\r\n\r\n  padding: 0;\r\n  margin: 0;\r\n  background-image: linear-gradient(to right,  rgb(8, 6, 2), rgb(90, 70, 73));\r\n  height: 100vh;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n\r\ndiv {\r\n\r\n  transition: all 1s;\r\n\r\n}\r\n\r\n\r\n.menu-titulo  {\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  padding-top: 3%;\r\n}\r\n\r\nh1 {\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  color: white;\r\n}\r\n\r\n\r\n.titulo-opcion {\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n  font-size: 20px;\r\n  font-weight: 300;\r\n  color: white;\r\n  \r\n}\r\n\r\n.opciones {\r\n\r\n  width: 100%;\r\n  max-height: 30px;\r\n  margin-left: 5px;\r\n  margin-bottom: 2px;\r\n  transition: max-height 0.5s ease-in-out;\r\n  overflow: hidden;\r\n\r\n}\r\n\r\n.titulo-opcion:hover {\r\n\r\n  cursor: pointer;\r\n  background-color: rgb(83, 72, 72);\r\n\r\n}\r\n\r\n.nav {\r\n\r\n  margin-left: 30px;\r\n\r\n\r\n}\r\n\r\n.activo {\r\n \r\n  max-height: 250px;\r\n  \r\n}\r\n\r\n.oculto {\r\n \r\n  height: 30px;\r\n \r\n}\r\n\r\n.mostrar {\r\n\r\n  display: block;\r\n\r\n}\r\n\r\nul {\r\n\r\n  transition: all 2s ease;\r\n\r\n}\r\n\r\nul li {\r\n\r\n  display: inline-flex;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n  width:max-content;\r\n  margin-right: 15px;\r\n  list-style: none;\r\n  color: white;\r\n  \r\n}\r\n\r\nul li:hover {\r\n\r\n  background-color: white;\r\n  color: black;\r\n}\r\n\r\na {\r\n \r\n  color: white;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n  font-size: 20px;\r\n  margin-left: 10px;\r\n  font-weight: 300;\r\n  cursor: pointer;\r\n\r\n\r\n}\r\n\r\na:hover {\r\n\r\n  color: black;\r\n\r\n}\r\n\r\ni {\r\n\r\n  font-size: 20px;\r\n\r\n}\r\n\r\n.linea {\r\n\r\n  display: block;\r\n  height: 1px;\r\n  width: 200px;\r\n  background-color: white;\r\n  transition: width 2s ease-in;\r\n\r\n}\r\n\r\n\r\n.footer {\r\n\r\n  /* position: fixed; */\r\n /* left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  color: white;\r\n  text-align: center;\r\n  \r\n}\r\n\r\n.footer h4 a{\r\n\r\n  font-size: 20px;\r\n\r\n}\r\n*/\r\n\r\n:root {\r\n\r\n--color-white: white;\r\n\r\n}\r\n\r\n.navegador  {\r\n\r\n  padding: 0;\r\n  margin: 0;\r\n  /* background-image: linear-gradient(to right,  rgb(8, 6, 2), rgb(90, 70, 73)); */\r\n  background-color:  rgba(0,0,0,0.4); \r\n   height: 100vh;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.nav {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n  flex-wrap: nowrap;\r\n  overflow-y: hidden;\r\n  overflow-x: auto;\r\n  width: 100%;\r\n  height: 100px;\r\n \r\n  gap: 1em;\r\n  position: relative;\r\n  \r\n  padding: 1.5rem;\r\n\r\n}\r\n\r\n\r\n.opciones {\r\n\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 1em;\r\n  height: 60px;\r\n  width: 180px;\r\n  min-width: 180px;\r\n  color: white;\r\n  --color-white: white;\r\n  border-bottom: 1px dotted white;\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.opciones:hover {\r\n\r\n  background-color: white;\r\n  color: black;\r\n  --color-white: black;\r\n  border-bottom: 1px dotted black;\r\n\r\n}\r\n\r\n.activo {\r\n\r\n  /* background-color: rgba(231, 101, 14, 0.5); */\r\n\r\n  border-bottom: 2px solid white;\r\n\r\n}\r\n\r\n.nav::-webkit-scrollbar {\r\n\r\n  width: 0.5rem;\r\n  height: 0.5rem;\r\n\r\n}\r\n\r\n.nav::-webkit-scrollbar-thumb {\r\n\r\n border-radius: 0.5rem;\r\n background-color: white;\r\n visibility: hidden;\r\n\r\n}\r\n\r\n.nav:hover::-webkit-scrollbar-thumb {\r\n\r\n  visibility: visible;\r\n\r\n}\r\n\r\n.titulo-opcion {\r\n\r\n  font-size: 17px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center  ;\r\n  flex-wrap: wrap;\r\n  color: var(--color-white);\r\n\r\n}\r\n\r\n.items  {\r\n\r\n  margin:10px;\r\n  display:flex;\r\n  position: relative;\r\n  width: 100%;\r\n  height: auto;\r\n\r\n}\r\n\r\nul {\r\n\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  height: auto;\r\n  gap: 0.5em;\r\n  width: 100%;\r\n  padding-right: 20px;\r\n}\r\n\r\n\r\nli {\r\n\r\n  margin:5px;\r\n   display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 0.5em;\r\n  font-size: 15px;\r\n  width: 100px;\r\n  min-width: 100px;\r\n  height: 100px;\r\n  color: white;\r\n  border-bottom: 1px dotted white;\r\n  padding: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\nli:hover {\r\n\r\n  background-color: white;\r\n  color: black;\r\n  border-bottom: 1px dotted black;\r\n  --color-white:black;\r\n}\r\n\r\na {\r\n\r\n  text-decoration: none;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  margin: 0;\r\n  padding: 0;\r\n  color: var(--color-white);\r\n\r\n}\r\n\r\ni {\r\n\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.perfil {\r\n\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n\r\n}\r\n\r\n.footer {\r\n\r\n  /* position: fixed; */\r\n left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  color: white;\r\n  text-align: center;\r\n  \r\n}\r\n\r\n.footer h4 a{\r\n\r\n  font-size: 20px;\r\n\r\n}\r\n\r\n.menu-titulo  {\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1px;\r\n  flex-wrap: wrap;\r\n  color: white;\r\n  padding-top: 3%;\r\n}\r\n\r\n.menu-titulo p {\r\n\r\n  font-size: 20px;\r\n  align-items: center;\r\n}\r\n\r\n\r\n.md-48 {\r\n\r\n  font-size: 48px;\r\n}\r\n\r\n\r\n.material-symbols-outlined {\r\n  font-variation-settings:\r\n  'FILL' 0,\r\n  'wght' 400,\r\n  'GRAD' 0,\r\n  'opsz' 24\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
